import React from "react";

const ProjectCardTitle = ({ title = "" }) => {
	return <h6 className='font-bold text-2xl text-accent'>{title}</h6>;
};

export default ProjectCardTitle;
